import { sumCapitalInvest, sumDebtInvest } from "./sumProperty";
import {
  SumDebtPersonalValue,
  SumOtherDebtAmount,
} from "./sumValueBalance";

// คำนวณสินทรัพย์รวมจากรายการปัจจุบันชุดเดียวกับหน้าสมดุล แล้วใช้อ้างอิงทั้งค่าอัตราส่วนและตัวหารที่แสดงผล
export const calculateDebtToTotalAssets = ({
  balanceData,
  addInvest = [],
  returnInsurance = [],
}) => {
  const totalAssets =
    Number(balanceData?.sum_property_asset || 0) +
    SumDebtPersonalValue(balanceData) +
    sumCapitalInvest(addInvest, returnInsurance) +
    sumDebtInvest(balanceData) +
    Number(balanceData?.sum_property_private || 0) +
    SumOtherDebtAmount(balanceData) +
    Number(balanceData?.sum_property_intangible || 0);
  const totalDebt = Number(balanceData?.debt_propotion || 0);

  return {
    totalAssets,
    ratio: totalAssets > 0 ? (totalDebt / totalAssets) * 100 : 0,
  };
};
